import { render, staticRenderFns } from "./boleto2.vue?vue&type=template&id=78fbb7be&scoped=true"
import script from "./boleto2.vue?vue&type=script&lang=js"
export * from "./boleto2.vue?vue&type=script&lang=js"
import style0 from "./boleto2.vue?vue&type=style&index=0&id=78fbb7be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fbb7be",
  null
  
)

export default component.exports